const formatPrice = (price) => {
  return price.toLocaleString("fr-FR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

/** Checkout page: always 2 decimal places (TTC, HT, VAT, fees). */
export function formatCheckoutMoney(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return "—";
  }
  return n.toLocaleString("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export default formatPrice;
